import axios from "axios";
import { server } from "../api";

const buildSymbolPayload = (symbol = {}) => {
  const payload = {};
  if (symbol.symbol_type !== undefined)
    payload.symbol_type = symbol.symbol_type;
  if (symbol.position_x_meters !== undefined) {
    payload.position_x_meters = symbol.position_x_meters;
  }
  if (symbol.position_y_meters !== undefined) {
    payload.position_y_meters = symbol.position_y_meters;
  }
  if (symbol.rotation !== undefined) payload.rotation = symbol.rotation;
  if (symbol.scale !== undefined) payload.scale = symbol.scale;
  if (symbol.label !== undefined) payload.label = symbol.label;
  return payload;
};

const IndoorPositioningSymbols = {
  GetSymbols: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/symbols`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取物件標記失敗",
          data: [],
        }
      );
    }
  },

  CreateSymbol: async (machineID, symbol) => {
    if (!machineID) {
      return { code: 400, message: "缺少室內定位機器 ID" };
    }
    const payload = buildSymbolPayload(symbol);
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/symbols`,
        payload
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增物件標記失敗",
        }
      );
    }
  },

  UpdateSymbol: async (id, symbol) => {
    const payload = buildSymbolPayload(symbol);
    try {
      const response = await axios.put(
        `${server}indoor-positioning/symbols/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新物件標記失敗",
        }
      );
    }
  },

  DeleteSymbol: async (id) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/symbols/${id}`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "移除物件標記失敗",
        }
      );
    }
  },
};

export default IndoorPositioningSymbols;
